import React from "react";
import { useFormikContext } from "formik";
import StreamSelectField from "data-lake/components/StreamSelectField";
import TimeRangeField from "data-lake/components/DataLakeActionModals/TimeRangeField";
import InclusionTypeField from "data-lake/components/DataLakeActionModals/InclusionTypeField";
import FieldsFiltersField from "data-lake/components/DataLakeActionModals/FieldsFiltersField";
const InternalFormFieldsComponent = ({ submitButtonText, hourOnly }) => {
  const {
    setFieldValue,
    values: { streamIds }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StreamSelectField, { value: streamIds, disabled: false, onChange: (value) => setFieldValue("streamIds", value) }), /* @__PURE__ */ React.createElement(TimeRangeField, { submitButtonText, hourOnly }), /* @__PURE__ */ React.createElement(InclusionTypeField, null), /* @__PURE__ */ React.createElement(FieldsFiltersField, null));
};
export default InternalFormFieldsComponent;
